 export const environment={
   baseUrl: 'https://api.iskedo.com',
   ticketBaseUrl:'https://api.tickets.zimo.one',
   locationKey: "AIzaSyBQl-eomjpEuiSTDZhIdwx63FAtQzdfyes",
}

